module.exports = {
  "logo-alt": "PlanetCross File Exchange",
  "auth-planetx-about-title": "PlanetCrossとは?",
  "auth-planetx-about-description":
    "PlanetCrossは、高い安全性を保ち組織間での分散型データ連携を実現します。 組織間のデータ連携を容易に且つ、高いセキュリティを担保するために、　 先進的で実績のあるソリューションを提供します。",
  "auth-planetfx-about-title": "File Exchangeとは?",
  "auth-planetfx-about-description":
    "FileExchange はPlanetCrossの仕組みを活用するファイル連携ソリューションです。組織間で追跡可能な利便性の高いファイル連携サービスを実現します。",
  "auth-form-login-title": "アカウントを入力してください",
  "auth-form-register-title": "アカウントを作成する",
  "auth-form-recover-title": "パスワードを忘れた場合",
  "auth-form-login": "ログイン",
  "auth-form-register": "新規登録",
  "auth-form-continue": "次へ",
  "auth-form-recover-link": "パスワードを忘れた場合",
  "auth-login-form-email-label": "メールアドレスを入力してください",
  "auth-login-form-email-placeholder": "メールアドレス",
  "auth-login-form-password-label": "パスワードを入力してください",
  "auth-login-form-password-placeholder": "パスワード",
  "auth-register-form-email-label": "メールアドレスを入力してください",
  "auth-register-form-email-placeholder": "メールアドレス",
  "auth-register-form-password-label": "パスワードを作成してください",
  "auth-register-form-password-placeholder": "パスワード",
  "auth-form-register-password-strength-title": "パスワード強度",
  "auth-form-register-password-strength-weak": "弱",
  "auth-form-register-password-strength-medium": "中",
  "auth-form-register-password-strength-strong": "強",
  "dashboard-header-upload": "アップロード",
  "dashboard-no-files": "表示するファイルはありません",
  "dashboard-exchange-expired": "期限切れ",
  "dashboard-expires": "期限切れ",
  "dashboard-expires-days": "日",
  "dashboard-no-files-upload":
    "<a>アップロード</a> をクリックしてファイルの共有をはじめましょう",
  "dashboard-files-incoming-title": "受信ファイル",
  "dashboard-files-outgoing-title": "送信ファイル",
  "dashboard-files-outgoing-download": "ダウンロード",
  "dashboard-files-outgoing-share": "再送信する",
  "dashboard-modal-drag-and-drop":
    "ファイルをここにドラッグし、<br>アップロードする",
  "dashboard-modal-cancel": "キャンセル",
  "dashboard-modal-choose-files": "ファイルを選ぶ",
  "dashboard-modal-upload-files": "アップロード",
  "dashboard-modal-share-files": "ファイル送信",
  "dashboard-modal-files-title": "ファイル",
  "dashboard-modal-share": "送信",
  "dashboard-modal-form-email-label": "送信先",
  "dashboard-modal-form-expires-label": "有効期限",
  "dashboard-modal-form-at": "",
  "dashboard-modal-form-on": "",
  "dashboard-modal-form-hours": "時間",
  "dashboard-modal-form-days": "日間",
  "dashboard-modal-emails-placeholder": "メールアドレスを入力してください",
  "dashboard-modal-message-placeholder": "メッセージを入力してください",
  "dashboard-modal-validuntil-placeholder": "テスト",
  "dashboard-modal-incomplete-exchanges": "You have incompleted exchanges:",
  "dashboard-modal-invalid-email":
    "入力されたメールアドレスは有効ではありません",
  "dashboard-dropdown-account": "アカウント情報",
  "dashboard-dropdown-logout": "ログアウト",
  "dashboard-activity-title": "アクティビティ",
  "dashboard-empty-activity": "アクティビティはありません",
  "dashboard-activity-filter-all": "すべて",
  "dashboard-activity-filter-sent": "送付済み",
  "dashboard-activity-filter-received": "受信",
  "modal-error-default-message": "エラーが発生しました",
  "modal-ok-button": "Ok",
  UNAUTHORIZED:
    "セッションの期限が切れています。もう一度ログインしてください。",
  INTERNAL_SERVER_ERROR:
    "問題が発生しましたため、リクエストを完了できませんでした。システムの管理者に連絡してください。",
  ACCESS_DENIED: "アクセスが 拒否 され まし た",
  ENTITY_NOT_FOUND: "エンティティが見つかりませんでした。",
  COULD_NOT_READ_FILE: "ファイルにアクセスすることができません。",
  INVALID_EMAIL:
    "入力されたメールアドレスは有効ではありません。詳細を確認のうえもう一度やり直してください。",
  INVALID_EXPIRATION_DATE:
    "入力された有効期限は正しくありません。詳細を確認のうえもう一度やり直してください。",
  EMAIL_NOT_REGISTERED:
    "入力されたメールアドレスは登録されていません。詳細を確認のうえもう一度やり直してください。",
  DUPLICATE_RECIPIENT: "DUPLICATE_RECIPIENT",
  CANNOT_MODIFY_EXCHANGE: "CANNOT_MODIFY_EXCHANGE",
  EXCHANGE_ILLEGAL_STATUS: "EXCHANGE_ILLEGAL_STATUS",
  XCHANGE_XROAD_MEMBER_RESOLUTION_FAILED:
    "EXCHANGE_XROAD_MEMBER_RESOLUTION_FAILED",
  EXCHANGE_SERVICE_ERROR: "EXCHANGE_SERVICE_ERROR",
  EXCHANGE_NO_RECIPIENTS: "受信者が見つかりません。",
  EXCHANGE_NO_SENDER: "送信者が見つかりません。",
  EXCHANGE_NO_SUCH_RECEIVER: "受信者がみつかりません。",
  EXCHANGE_NO_FILES: "EXCHANGE_NO_FILES",
  EXCHANGE_EXPIRED: "EXCHANGE_EXPIRED",
  EXCHANGE_DUPLICATE: "EXCHANGE_DUPLICATE",
  "dashboard-incoming-received-from": "から受信しました",
  "dashboard-files": "ファイル",
  "dashboard-you-sent": "を送信しました",
  "dashboard-to": "に",
  "dashboard-and": "と",
  "dashboard-others": "他",
  "dashboard-shared-with": "宛先",
  "auth-verification-modal-title": "アカウントを確認する",
  "auth-verification-modal-text":
    "確認メールが登録されたメールアドレスに送信されました。 メール内のリンクからアカウントを認証し、PlanetCross File Exchangeの使用を開始してください。",
  "auth-verification-modal-back": "ログインに戻る",
  "auth-verification-complete-modal-title": "登録は完了しました。",
  "auth-back-to-login": "ログインに戻る",
  "auth-verification-complete-modal-text":
    "メールアドレスを確認していただきありがとうございます。 登録は完了しました。 登録時に指定したメールアドレスとパスワードを使用してログインできます。",
  "auth-form-invalid": "ユーザー名またはパスワードが正しくありません。",
  "confirm-delete": "ファイルの削除",
  "confirm-incoming-modal-delete":
    "このファイルを削除しますか。一度削除すると元に戻すことはできません。 このファイルの共有者は、削除後もファイルを引き続き使用できます。",
  "confirm-outgoing-modal-delete":
    "ファイルの削除このファイルを削除しますか。一度削除すると元に戻すことはできません。 このファイルの宛先もファイルを利用することができなくなります。<br><br>本当に削除しますか。",
  "auth-form-recover": "メール送信",
  "auth-form-recover-description":
    "ご登録のメールアドレスを入力すると、パスワードを変更するためのリンクがメールアドレスに送信されます。",
  "email-sent": "メールを送信しました",
  "recover-email-content":
    "ご登録のメールアドレスに、パスワードを変更するためのリンクが。送信されまあした",
  "auth-new-password": "新しいパスワード",
  "auth-confirm-new-password": "新しいパスワード(確認)",
  "auth-password-changed": "パスワードは変更されました。",
  "auth-change-password-description":
    "ご登録メールアドレス{email}のパスワードを変更します。",
  "auth-update-password": "パスワードを変更する",
  "auth-password-changed-description":
    "登録されたメールアドレスと更新されたパスワードでログインすることが可能になりました。",
  "auth-verification-failed": "変更に失敗しました",
  "auth-verification-failed-description":
    "認証リンクの有効期限が切れています。再度登録してください。",
  "auth-go-to-registration": "登録画面へ戻る",
  DOMAIN_NOT_REGISTERED: "このドメインのメールアドレスは登録対象外です。",
  "auth-reset-password": "パスワードの変更",
  "password-protect": "パスワード保護",
  "whats-this": "詳細はこちら",
  "password-protect-tooltip":
    "ファイルをパスワードで保護するためにこのボックスをチェックしてください。 パスワードはシステムによって自動的に生成され、ファイル交換メール通知で受信者に送信されます。",
  "upload-modal-add-files": "ファイルを追加",
  "upload-modal-add-files-description": "ここにファイルをドラッグする:",
  "user-profile-password-changed": "パスワードは変更されました。",
  "user-profile-title": "あなたのアカウント",
  "back-to-dashboard": "ダッシュボードに戻る",
  "profile-account-details": "アカウントの詳細",
  "profile-registered-email": "登録されているメールアドレス",
  "profile-change-password": "パスワードの変更",
  "profile-current-password": "現在のパスワード ",
  "file-not-available":
    "指定されたファイルは見つかりません。ダウンロードのリンクは間違っているもしくは期限が切れています。",
  FIRST_LOGIN: "ようこそPlanetCross File Exchangeへ!",
  OUTGOING_NEW:
    "<span title='{receiverFullEmail}'>{receiver}</span> {otherReceivers}{count}個のファイルを送信しました。",
  OUTGOING_DELETED_BY_SENDER:
    "<span title='{receiverFullEmail}'>{receiver}</span> {otherReceivers}送信した{count}個のファイルを削除しました。",
  INCOMING_NEW:
    "<span title='{senderFullEmail}'>{senderName}</span>から{count}個のファイルを受信しました。",
  INCOMING_DELETED_BY_RECEIVER:
    "<span title='{senderFullEmail}'>{senderName}</span>から受信した{count}個のファイルを削除しました。",
  INCOMING_DELETED_BY_SENDER:
    "<span title='{senderFullEmail}'>{senderName}</span>から受信した{count}個のファイルは<span title='{senderFullEmail}'>{senderName}</span>が削除しました。",
  INCOMING_EXPIRED:
    "<span title='{senderFullEmail}'>{senderName}</span>から受信した{count}個のファイルは期限が切れました。",
  INCOMING_EXPIRED_AND_DELETED:
    "<span title='{senderFullEmail}'>{senderName}</span>から受信した{count}個のファイルは期限が切れ、自動的に削除されました。",
  "activity-other-receivers":
    "<span title='{fullEmails}'>と他の{count}人に</span>",
  "dashboard-other-receivers-tooltip":
    "<strong class='tooltip' tooltip-title='{otherReceivers}'>と他の{count}人に</strong>",
  XROAD_MEMBER_RESOLUTION_FAILED: "無効なメールアドレスです。",
  PASSWORD_MISMATCH: "現在のパスワードが間違っています。",
  "date-picker-format": "yyyy/MM/dd",
  loading: "読み込み中",
  "exchange-file-upload-failed": "アップロードが失敗しました。",
  EXCHANGE_MAX_TOTAL_SIZE_EXCEEDED:
    "合計のファイルサイズが大きすぎてアップロードできませんでした。",
  "dashboard-incoming-exchange-received":
    "<strong>{sender}から{count}個のファイルを受信しました。</strong>",
  "dashboard-outgoing-exchange-sent":
    "<strong>{receiver}</strong> {outgoingOtherReceivers}に<strong>{count}</strong>個のファイルを送信しました。",
  "entity-too-large":
    "ファイルサイズが大きすぎてアップロードできませんでした。",
  "is-not-registered": " が登録されていません。"
};
